import React from "react";

import "./Row.scss";

const Row: React.FC = ({ children }) => <div className="c-row">{children}</div>;

export default Row;
